const isNumberLike = (value) => {
  if (typeof value === 'number') return !Number.isNaN(value)
  if (typeof value === 'string' && value.trim() !== '') return !Number.isNaN(Number(value))
  return false
}

const isLngLatPair = (entry) => (
  Array.isArray(entry)
  && entry.length >= 2
  && isNumberLike(entry[0])
  && isNumberLike(entry[1])
)

const isRing = (entry) => Array.isArray(entry) && entry.length > 0 && isLngLatPair(entry[0])
const isPolygon = (entry) => Array.isArray(entry) && entry.length > 0 && isRing(entry[0])
const isMultiPolygon = (entry) => Array.isArray(entry) && entry.length > 0 && isPolygon(entry[0])

const toLatLngRing = (ring = []) => ring.map(([lng, lat]) => [lat, lng])
const toLatLngPolygon = (rings = []) => rings.map(toLatLngRing)
const toLatLngMultiPolygon = (polygons = []) => polygons.map(toLatLngPolygon)

export const normalizePolygonCoordinates = ({ geometry, coordinates, type } = {}) => {
  const geomType = geometry?.type || type
  const geomCoords = geometry?.coordinates || coordinates || []

  if (geomType === 'Polygon') {
    return { type: 'Polygon', coordinates: toLatLngPolygon(geomCoords) }
  }

  if (geomType === 'MultiPolygon') {
    return { type: 'MultiPolygon', coordinates: toLatLngMultiPolygon(geomCoords) }
  }

  if (isMultiPolygon(geomCoords)) {
    return { type: 'MultiPolygon', coordinates: toLatLngMultiPolygon(geomCoords) }
  }

  if (isPolygon(geomCoords)) {
    return { type: 'Polygon', coordinates: toLatLngPolygon(geomCoords) }
  }

  if (isRing(geomCoords)) {
    return { type: 'Polygon', coordinates: [toLatLngRing(geomCoords)] }
  }

  return { type: null, coordinates: [] }
}

export const buildPolygonPayloadCoordinates = ({
  geometry,
  coordinates,
  type,
  flattenSingleRing = true,
} = {}) => {
  const normalized = normalizePolygonCoordinates({ geometry, coordinates, type })
  const { type: normalizedType, coordinates: normalizedCoords } = normalized

  if (!flattenSingleRing) return normalizedCoords

  if (normalizedType === 'Polygon' && normalizedCoords.length === 1) {
    return normalizedCoords[0]
  }

  if (normalizedType === 'MultiPolygon' && normalizedCoords.length === 1) {
    return normalizedCoords[0].length === 1
      ? normalizedCoords[0][0]
      : normalizedCoords[0]
  }

  return normalizedCoords
}
